import React from "react";

import classes from "./ResimdoIcon.module.scss";
import * as propIcons from '../../../prop-icons.json';
import basicIcons from '../../../basic-icons.json';
import newsIcons from '../../../news-icons.json';
import bonusIcons from '../../../bonus-icons.json';
import applicationsIcons from '../../../applications-icons.json';
import socialIcons from '../../../social-icons.json';
const allIcons = {
  ...propIcons,
  ...basicIcons,
  ...newsIcons,
  ...bonusIcons,
  ...applicationsIcons,
  ...socialIcons,
};

type Size = 'XS' | 'SM' | 'MD' | 'LG' | 'XL' | 'XXS';
type MobileSize = Size | '50';

export const ResimdoIcon = (
  {
    icon,
    size = 'MD',
    color = '#FFFFFF',
    backgroundColor = '#333333',
    mobileSize,
    alt = '',
  }: {
    icon: string;
    size?: Size;
    color?: string;
    backgroundColor?: string;
    mobileSize?: MobileSize;
    alt?: string;
  }) => {
  const sizeClass = `size-${size.toLowerCase()}`;
  const mobileSizeClass = mobileSize ? `mobile-${mobileSize.toLowerCase()}` : undefined;

  const selectedIcon = React.useMemo(() => allIcons[icon], [icon]);

  const coloredIcon = React.useMemo(() => {
    if (!selectedIcon) return null;
    return color ? selectedIcon.replaceAll('#FFFFFF', color) : selectedIcon;
  }, [selectedIcon, color]);

  const bgColoredIcon = React.useMemo(() => {
    if (!coloredIcon) return null;
    return backgroundColor ? coloredIcon.replaceAll('#333333', backgroundColor) : coloredIcon;
  }, [coloredIcon, backgroundColor]);

  const IconComponent = React.useMemo(() => {
    return <img src={`data:image/svg+xml,${encodeURIComponent(bgColoredIcon)}`} className={`${classes[sizeClass]} ${mobileSizeClass ? classes[mobileSizeClass] : ''}`} alt={alt} {...(!alt && { role: 'presentation' })} />;
  }, [bgColoredIcon, sizeClass, mobileSizeClass, alt]) as React.ReactNode;

  return (
    <div className={`${classes.wrapperDiv} ${classes[sizeClass]} ${mobileSizeClass ? classes[mobileSizeClass] : ''}`}>
      {IconComponent}
    </div>
  );
};

export default ResimdoIcon;
